// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectParkingTypeQueryResult, selectParkingTypesPageLoading, selectParkingTypesShowInitWaitingMessage} from '../_selectors/parking-type.selectors';

export class ParkingTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectParkingTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectParkingTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectParkingTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
